export const globalSearchApiQueryKeys = {
  all: () => ['globalSearch'] as const,
  byTerm: (term: string, includeCancelled: boolean) =>
    ['globalSearch', term, includeCancelled] as const,
};
